var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import { startTransition, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Avatar, Flex, Spin, Typography } from "antd";
import { ReactComponent as SearchIcon } from "./../../../assets/icons/search.svg";
import SearchApi from "./../../../api/SearchApi.js";
import { EVENT_ACTIONS, track } from "./../../../lib/gtag.js";
import {
  CATEGORY_EVENTS,
  CATEGORY_TO_PATH,
  SEARCH_CATEGORIES
} from "./../../../pages/search/searchService.js";
import { useTranslation } from "@inscore/shared";
import "./headerSearch.css";
const { Text } = Typography;
const ALL_FILTER = "all";
const ALL_LIMIT_PER_CATEGORY = {
  popular: 3,
  results: 5
};
const FILTERS = [
  { key: ALL_FILTER, categories: Object.values(SEARCH_CATEGORIES) },
  { key: "teams", categories: [SEARCH_CATEGORIES.Teams] },
  { key: "leagues", categories: [SEARCH_CATEGORIES.Competitions] },
  { key: "players", categories: [SEARCH_CATEGORIES.Players] }
];
const HeaderSearch = ({ mobile = false }) => {
  const { t } = useTranslation();
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [filter, setFilter] = useState(FILTERS[0].key);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!open)
      return;
    const searchApi = SearchApi.search();
    setLoading(true);
    track(EVENT_ACTIONS.SEARCH_HIT, { value: query });
    searchApi.call({ query, type: 1 }).then((response) => {
      var _a;
      setData((_a = response.data) != null ? _a : {});
      setLoading(false);
    }).catch((error) => {
      if ((error == null ? void 0 : error.name) !== "CanceledError") {
        console.error(error);
        setLoading(false);
      }
    });
    return () => searchApi.cancel();
  }, [open, query]);
  const items = useMemo(() => {
    const { categories } = FILTERS.find(({ key }) => key === filter);
    const limit = filter === ALL_FILTER ? query ? ALL_LIMIT_PER_CATEGORY.results : ALL_LIMIT_PER_CATEGORY.popular : void 0;
    return categories.flatMap(
      (category) => {
        var _a;
        return ((_a = data[category]) != null ? _a : []).slice(0, limit).map((item) => __spreadProps(__spreadValues({}, item), { category }));
      }
    );
  }, [data, filter, query]);
  const focusInput = () => {
    var _a;
    return (_a = inputRef.current) == null ? void 0 : _a.focus();
  };
  const handleFocus = () => {
    if (open)
      return;
    setOpen(true);
    track(EVENT_ACTIONS.SEARCH);
  };
  const closeSearch = () => {
    var _a;
    setOpen(false);
    setInputValue("");
    setQuery("");
    setFilter(FILTERS[0].key);
    (_a = inputRef.current) == null ? void 0 : _a.blur();
  };
  const handleBlur = (e) => {
    var _a;
    if (!((_a = wrapperRef.current) == null ? void 0 : _a.contains(e.relatedTarget))) {
      closeSearch();
    }
  };
  const handleChange = (e) => {
    setInputValue(e.target.value);
    startTransition(() => setQuery(e.target.value));
  };
  const handleKeyDown = (e) => {
    if (e.key === "Escape")
      closeSearch();
  };
  const onItemClick = (category) => {
    const event = CATEGORY_EVENTS[category];
    event && track(event);
    closeSearch();
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: wrapperRef,
      className: `header-search${mobile ? " mobile" : ""}${open ? " open" : ""}`,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      children: [
        mobile && /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: "header-search_trigger",
            onClick: focusInput,
            "aria-label": t("search"),
            children: /* @__PURE__ */ jsx(SearchIcon, { className: "stroke-base" })
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "header-search_bar", children: [
          /* @__PURE__ */ jsxs("div", { className: "header-search_field", onClick: focusInput, children: [
            /* @__PURE__ */ jsx(SearchIcon, { className: "stroke-base header-search_icon" }),
            /* @__PURE__ */ jsx(
              "input",
              {
                ref: inputRef,
                className: "header-search_input",
                value: inputValue,
                onChange: handleChange,
                onFocus: handleFocus,
                "aria-label": t("search")
              }
            )
          ] }),
          mobile && /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              className: "header-search_cancel",
              onClick: closeSearch,
              tabIndex: open ? 0 : -1,
              children: t("cancel")
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: "header-search_menu",
            onMouseDown: (e) => e.preventDefault(),
            children: [
              /* @__PURE__ */ jsx(Flex, { gap: 8, wrap: true, children: FILTERS.map(({ key }) => /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  className: `header-search_chip header-search_filter${filter === key ? " active" : ""}`,
                  onClick: () => setFilter(key),
                  tabIndex: open ? 0 : -1,
                  children: t(key)
                },
                key
              )) }),
              /* @__PURE__ */ jsx("div", { className: "header-search_results", children: loading && !items.length ? /* @__PURE__ */ jsx(Flex, { justify: "center", style: { padding: 12 }, children: /* @__PURE__ */ jsx(Spin, { size: "small" }) }) : items.length ? /* @__PURE__ */ jsx(
                Flex,
                {
                  gap: query ? 4 : 8,
                  wrap: !query,
                  vertical: !!query,
                  children: items.map((item) => /* @__PURE__ */ jsxs(
                    Link,
                    {
                      to: `/${CATEGORY_TO_PATH[item.category]}/${item.id}`,
                      className: query ? "header-search_row" : "header-search_chip",
                      onClick: () => onItemClick(item.category),
                      tabIndex: open ? 0 : -1,
                      title: item.moreInfo,
                      children: [
                        item.iconUrl && /* @__PURE__ */ jsx(
                          Avatar,
                          {
                            src: item.iconUrl,
                            size: query ? 20 : 16,
                            className: "header-search_item-icon"
                          }
                        ),
                        /* @__PURE__ */ jsx("span", { children: item.name })
                      ]
                    },
                    `${item.category}-${item.id}`
                  ))
                }
              ) : !loading && /* @__PURE__ */ jsx(Text, { children: t("no_results_suggestion") }) })
            ]
          }
        )
      ]
    }
  );
};
var stdin_default = HeaderSearch;
export {
  stdin_default as default
};
